<template>
  <div>
    <div v-if="context === 'onlinebooking'" class="close-button btn-back" @click="showSignUp()">
      <font-awesome-icon :icon="['fas', 'caret-left']" class="text-grey" />&nbsp;Back
    </div>
    <div v-if="context === 'onlinebooking' || context === 'enquirylogin'" class="close-button btn-close" @click="$emit('closeModal')">
      Close&nbsp;<Cross color="grey" :width="14" :height="14" alt="close" class="close-button btn-close cross" />
    </div>

    <div class="signInModal" :class="{'login_window_client_area' : context === 'clientarea','background-stoneWhite' : true, 'login_window_ob' : context === 'onlinebooking' || context === 'enquirylogin' || context === 'splashbooking'}">

    <div v-if="context === 'clientarea' && context !== 'splashbooking'" v-show="!showOldSignInActive">
  <h1 class="h3 login_head client-area-head">
    Log in to your Account
  </h1>
  <div class="client-area-content">
    <h3>Lead bookers guests and Trip managers</h3>
    <a href="/account" class="btn-primary-dark-sm">
      View Bookings
    </a>

    <h3>Travel Agents</h3>
    <a href="" @click.prevent="showOldSignIn" class="btn-secondary-dark-sm">
      Travel Agent Log in
    </a>
  </div>
    </div>

  <div v-show="showOldSignInActive">
      <div v-if="context === 'onlinebooking' || context === 'enquirylogin'">
        <h1 class="h3 login_head uppercase ob-head">
          Log in
        </h1>
      </div>

      <div v-else-if="context === 'clientarea'">
        <h1 class="h3 login_head client-area-head" v-html="heading" />
      </div>



      <div v-if="context === 'clientarea'" class="login_bottom travel-agent-help">
        <h3>Travel agents only</h3>
        <p>If you are having difficulty logging in, please contact your Account Manager. Your Account Manager will have previously provided your log in email address and password.</p>
      </div>

      <transition name="fade" mode="out-in">
        <!-- Loading -->
        <form v-if="step==='loading'" key="0">
          <div class="login_loading">
            <monogram-loader spinner />
          </div>
        </form>

        <!-- Login - Step 1 -->
        <div v-if="step==='step1'">
          <form key="2" @submit.prevent="auth">
            <!--<p class="text-center">
          Welcome <span class="bold">{{email}}</span>
        </p>-->
            <div>
              <p class="form__box--label">
                Email
              </p>

              <input v-model="email"
                     v-validate="'required'"
                     placeholder="Please enter your email"
                     type="text"
                     name="email"
                     class="credentials"
                     label="Email address"
                     @keydown="resetError()"
              >
            </div>
            <div>
              <p class="form__box--label" style="float:left">
                Password
              </p>
              <button type="button" style="float:right" @click="switchPasswordVisibility">
                <div v-show="passwordFieldType === 'password'" class="text-light-blue">
                  <font-awesome-icon :icon="['fas', 'eye']" aria-label="eye" size="sm" class="link-unstyle " />
                  Show
                </div>
                <div v-show="passwordFieldType === 'text'" class="text-light-blue">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" aria-label="eye" size="sm" class="link-unstyle " />
                  Hide
                </div>
              </button>
              <input v-model="password"
                     v-validate="'required'"
                     placeholder="Please enter your password"
                     class="credentials"
                     :type="passwordFieldType"
                     label="Password"
                     name="password"
                     @keydown="resetError()"
              >
            </div>

            <div class="login_errors">
              <span v-if="errorText" style="color:red" v-html="errorText" />
            </div>
            <div class="login_buttons">
              <button v-if="context != 'splashbooking'" type="submit" class="btn-primary-dark-md">
                Log in
              </button>
              <button v-if="context === 'splashbooking'" type="submit" class="btn-primary-dark-md">
                Continue to checkout
              </button>
            </div>
          </form>
          <!-- <div v-if="context !== 'splashbooking'">
            <p class="uppercase login_or semi-bold">
              or log in with:
            </p>
            <div class="login_or semi-bold social-icons">
              <div class="social-icon" @click="doFacebookLogin">
                <font-awesome-icon :icon="['fab', 'facebook-f']" size="2x" style="color:black" aria-label="facebook" :class="{'link-unstyle' : true, 'form__social--icon' : true, 'icon-hover' : true, 'clicked' : faceBookLoading }" />
              </div>

              <div class="social-icon" @click="doGoogleLogin">
                <font-awesome-icon :icon="['fab', 'google']" size="2x" style="color:black" aria-label="google" :class="{'link-unstyle' : true, 'form__social--icon' : true, 'icon-hover' : true, 'clicked' : googleLoading }" />
              </div>

              <div class="social-icon" @click="logInWithApple">
                <font-awesome-icon :icon="['fab', 'apple']" size="2x" style="color:black" aria-label="apple" :class="{'link-unstyle' : true, 'form__social--icon' : true, 'icon-hover' : true, 'clicked' : appleLoading }" />
              </div>
            </div>
          </div> -->
        </div>

        <!-- Forgotten password -->
        <form v-if="step==='forgottenpassword'" key="3" @submit.prevent="requestReset">
          <p class="text-center" v-html="forgottenPasswordIntroText" />
          <div>
            <input v-model="email"
                   v-validate="'required'"
                   placeholder="Email address"
                   label="Email address"
                   type="text"
                   name="email"
                   class="credentials"
                   @keydown="resetError()"
            >
          </div>
          <div class="login_errors">
            <span v-if="errorText" style="color:red" v-html="errorText" />
          </div>
          <div class="login_buttons">
            <button type="submit" class="btn-primary-dark-md">
              Submit
            </button><br>
          </div>
          <div class="login_bottom">
            <a class="text-dark" href="" @click.prevent="showLogin_Step1(); resetError()">Back to Login</a>
          </div>
        </form>

        <!-- Forgotten password - Confirmation -->
        <form v-if="step==='forgottenpassword_confirmation'" key="4">
          <p class="text-center" v-html="forgottenPassword_Confirmation" />
          <div class="login_bottom">
            <a href="" @click.prevent="showLogin_Step1(); resetError()">Proceed to Login</a>
          </div>
        </form>

        <!-- Reset password -->
        <form v-if="step==='resetpassword'" key="5" @submit.prevent="resetPassword">
          <p class="text-center">
            Please enter and confirm your password<br>
            Your password must be at least 8 characters long and must contain at least one numeric character.
          </p>
          <div class="login_reset">
            <input v-model="email"
                   placeholder="Email address"
                   label="Email address"
                   type="text"
                   name="email"
                   class="credentials"
                   readonly
                   @keydown="resetError()"
            >
            <input ref="newPassword"
                   v-model="newPassword"
                   v-validate="{ required: true, regex: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).{8,50}$/ }"
                   placeholder="New Password"
                   class="credentials"
                   label="Password"
                   type="password"
                   name="newPassword"
                   @keydown="resetError()"
            >
            <input v-model="newPasswordConfirm"
                   v-validate="'required|confirmed:newPassword'"
                   placeholder="Confirm password"
                   class="credentials"
                   label="Confirm password"
                   type="password"
                   name="newPasswordConfirm"
                   data-vv-as="newPassword"
                   @keydown="resetError()"
            >
          </div>
          <div class="login_errors">
            <span v-if="errorText" style="color:red" v-html="errorText" />
          </div>
          <div v-if="context" class="login_buttons">
            <button type="submit" class="btn-primary-dark-md">
              Submit
            </button><br>
          </div>
          <p class="login_bottom">
            <a href="" @click.prevent="showLogin_Step1(); resetError()">Back to Login</a>
          </p>
        </form>

        <!-- Reset password - Confirmation -->
        <form v-if="step==='resetpassword_confirmation'" key="6">
          <p class="login_intro" v-html="resetPassword_Confirmation" />
          <div class="login_bottom">
            <a href="" @click.prevent="showLogin_Step1(); resetError()">Proceed to Log in</a>
          </div>
        </form>
      </transition>
    </div>

      <div v-if="context === 'splashbooking'">

      <div v-if="context === 'onlinebooking' || context === 'enquirylogin'">
        <h1 class="h3 login_head uppercase ob-head">
          Log in
        </h1>
      </div>

      <div v-else-if="context === 'clientarea'">
        <h1 class="h3 login_head client-area-head" v-html="heading" />
      </div>

      <p v-if="context === 'clientarea'" style="margin-bottom: 0">
        <a class="text-dark" href="" @click.prevent="switchMode()">{{ mode === 'leadbooker' ? 'Log in as a Guest' : 'Lead Booker Login' }}</a>
      </p>

      <p v-if="context === 'clientarea'" class="login_bottom">
         OR <br>
        <a class="text-dark" href="/account">Continue with SSO</a></p>

      <transition name="fade" mode="out-in">
        <!-- Loading -->
        <form v-if="step==='loading'" key="0">
          <div class="login_loading">
            <monogram-loader spinner />
          </div>
        </form>

        <!-- Login - Step 1 -->
        <div v-if="step==='step1'">
          <form key="2" @submit.prevent="auth">
            <!--<p class="text-center">
          Welcome <span class="bold">{{email}}</span>
        </p>-->
            <div>
              <p class="form__box--label">
                Email
              </p>

              <input v-model="email"
                     v-validate="'required'"
                     placeholder="Please enter your email"
                     type="text"
                     name="email"
                     class="credentials"
                     label="Email address"
                     @keydown="resetError()"
              >
            </div>
            <div>
              <p class="form__box--label" style="float:left">
                Password
              </p>
              <button type="button" style="float:right" @click="switchPasswordVisibility">
                <div v-show="passwordFieldType === 'password'" class="text-light-blue">
                  <font-awesome-icon :icon="['fas', 'eye']" aria-label="eye" size="sm" class="link-unstyle " />
                  Show
                </div>
                <div v-show="passwordFieldType === 'text'" class="text-light-blue">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" aria-label="eye" size="sm" class="link-unstyle " />
                  Hide
                </div>
              </button>
              <input v-model="password"
                     v-validate="'required'"
                     placeholder="Please enter your password"
                     class="credentials"
                     :type="passwordFieldType"
                     label="Password"
                     name="password"
                     @keydown="resetError()"
              >
            </div>

            <p class="forgot_bottom">
              <a class="text-dark" @click="showLogin_ForgottenPassword()">Forgot password?</a>
            </p>

            <div class="login_errors">
              <span v-if="errorText" style="color:red" v-html="errorText" />
            </div>
            <div class="login_buttons">
              <button v-if="context != 'splashbooking'" type="submit" class="btn-primary-dark-md">
                Log in
              </button>
              <button v-if="context === 'splashbooking'" type="submit" class="btn-primary-dark-md">
                Continue to checkout
              </button>
            </div>
            <p v-if="mode === 'leadbooker' && step === 'step1'" class="sign-up-link">
              Don't have an account?  <a class="cursor text-dark" href="" @click.prevent="showSignUp()">Sign up</a>
            </p>
          </form>
          <!-- <div v-if="context !== 'splashbooking'">
            <p class="uppercase login_or semi-bold">
              or log in with:
            </p>
            <div class="login_or semi-bold social-icons">
              <div class="social-icon" @click="doFacebookLogin">
                <font-awesome-icon :icon="['fab', 'facebook-f']" size="2x" style="color:black" aria-label="facebook" :class="{'link-unstyle' : true, 'form__social--icon' : true, 'icon-hover' : true, 'clicked' : faceBookLoading }" />
              </div>

              <div class="social-icon" @click="doGoogleLogin">
                <font-awesome-icon :icon="['fab', 'google']" size="2x" style="color:black" aria-label="google" :class="{'link-unstyle' : true, 'form__social--icon' : true, 'icon-hover' : true, 'clicked' : googleLoading }" />
              </div>

              <div class="social-icon" @click="logInWithApple">
                <font-awesome-icon :icon="['fab', 'apple']" size="2x" style="color:black" aria-label="apple" :class="{'link-unstyle' : true, 'form__social--icon' : true, 'icon-hover' : true, 'clicked' : appleLoading }" />
              </div>
            </div>
          </div> -->
        </div>

        <!-- Forgotten password -->
        <form v-if="step==='forgottenpassword'" key="3" @submit.prevent="requestReset">
          <p class="text-center" v-html="forgottenPasswordIntroText" />
          <div>
            <input v-model="email"
                   v-validate="'required'"
                   placeholder="Email address"
                   label="Email address"
                   type="text"
                   name="email"
                   class="credentials"
                   @keydown="resetError()"
            >
          </div>
          <div class="login_errors">
            <span v-if="errorText" style="color:red" v-html="errorText" />
          </div>
          <div class="login_buttons">
            <button type="submit" class="btn-primary-dark-md">
              Submit
            </button><br>
          </div>
          <div class="login_bottom">
            <a class="text-dark" href="" @click.prevent="showLogin_Step1(); resetError()">Back to Log in</a>
          </div>
        </form>

        <!-- Forgotten password - Confirmation -->
        <form v-if="step==='forgottenpassword_confirmation'" key="4">
          <p class="text-center" v-html="forgottenPassword_Confirmation" />
          <div class="login_bottom">
            <a href="" @click.prevent="showLogin_Step1(); resetError()">Proceed to Log in</a>
          </div>
        </form>

        <!-- Reset password -->
        <form v-if="step==='resetpassword'" key="5" @submit.prevent="resetPassword">
          <p class="text-center">
            Please enter and confirm your password<br>
            Your password must be at least 8 characters long and must contain at least one numeric character.
          </p>
          <div class="login_reset">
            <input v-model="email"
                   placeholder="Email address"
                   label="Email address"
                   type="text"
                   name="email"
                   class="credentials"
                   readonly
                   @keydown="resetError()"
            >
            <input ref="newPassword"
                   v-model="newPassword"
                   v-validate="{ required: true, regex: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).{8,50}$/ }"
                   placeholder="New Password"
                   class="credentials"
                   label="Password"
                   type="password"
                   name="newPassword"
                   @keydown="resetError()"
            >
            <input v-model="newPasswordConfirm"
                   v-validate="'required|confirmed:newPassword'"
                   placeholder="Confirm password"
                   class="credentials"
                   label="Confirm password"
                   type="password"
                   name="newPasswordConfirm"
                   data-vv-as="newPassword"
                   @keydown="resetError()"
            >
          </div>
          <div class="login_errors">
            <span v-if="errorText" style="color:red" v-html="errorText" />
          </div>
          <div v-if="context" class="login_buttons">
            <button type="submit" class="btn-primary-dark-md">
              Submit
            </button><br>
          </div>
          <p class="login_bottom">
            <a href="" @click.prevent="showLogin_Step1(); resetError()">Back to Log in</a>
          </p>
        </form>

        <!-- Reset password - Confirmation -->
        <form v-if="step==='resetpassword_confirmation'" key="6">
          <p class="login_intro" v-html="resetPassword_Confirmation" />
          <div class="login_bottom">
            <a href="" @click.prevent="showLogin_Step1(); resetError()">Proceed to Log in</a>
          </div>
        </form>
      </transition>
    </div>
    </div>
  </div>
</template>

<script>

import Bus from '../../events/bus';
import SocialLogins from '../../mixins/socialLogins';
import MonogramLoader from '../MonogramLoader.vue';
import Cross from '../icons/Cross.vue';

export default {
  components: {
    MonogramLoader,
    Cross,
  },
  mixins: [SocialLogins],
  props: {
    context: { type: String, default: 'clientarea' }, // clientarea or onlinebooking or enquiryLogin
  },
  data() {
    return {
      email: null,
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
      passwordFieldType: 'password',
      heading: 'Log in to Your Account',
      step: 'loading',
      serverError_emailnotfound: false,
      serverError_unauthed: false,
      serverError: false,
      mode: 'leadbooker',
      errorMessages: {
        custom: {
          email: {
            required: 'Please enter your email address.',
          },
          password: {
            required: 'Please enter your password',
          },
          newPassword: {
            required: 'Please enter your password',
            regex: 'Your password does not meet the security requirements stated above',
          },
          newPasswordConfirm: {
            required: 'Please confirm your password',
            confirmed: 'Passwords do not match',
          },
        },
      },
      showOldSignInActive: false,
    };
  },
  computed: {
    currentContext() {
      console.log('Current context:', this.context);
      return this.context;
    },
    guestLoginURL() {
      return `${this.$store.getters['pages/currentPath']}?g=1`;
    },
    leadBookerLoginURL() {
      return this.$store.getters['pages/currentPath'];
    },
    errorText() {
      // Login Step 1
      if (this.step === 'step1') {
        if (this.errors.first('email')) { // return  vee validate error
          return this.errors.first('email');
        } if (this.errors.first('password')) { // return vee validate error
          return this.errors.first('password');
        } if (this.serverError_emailnotfound) { // error returned by server - email not found (404)
          return this.mode === 'leadbooker'
            ? 'We\'re sorry, but we don\'t have this email address on record. For assistance call us on <a href="tel:020 7377 8518" class="office number">+44 (0)20 7377 8518</a>.'
            : 'We\'re sorry, but we don\'t appear to have this email address on record.';
        } if (this.serverError_unauthed) { // error returned by server - password incorrect (401)
          return 'Incorrect password';
        }
      }
      // Forgotten password
      else if (this.step === 'forgottenpassword') {
        if (this.errors.first('email')) { // return  vee validate error
          return this.errors.first('email');
        } if (this.serverError_emailnotfound) { // error returned by server
          return this.mode === 'leadbooker'
            ? `We're sorry, but we don't have this email address on record.
                Did you use a different address when you made your booking? If you need assistance,
                please email <a href="mailto:predeparture@thethinkingtraveller.com">predeparture@thethinkingtraveller.com</a>.`
            : 'We\'re sorry, but we don\'t have this email address on record.';
        }
      }
      // Reset Password
      else if (this.step === 'resetpassword') {
        if (this.errors.first('newPassword')) { // return  vee validate error
          return this.errors.first('newPassword');
        } if (this.errors.first('newPasswordConfirm')) {
          return this.errors.first('newPasswordConfirm');
        } if (this.serverError) { // error returned by server
          return 'Unexpected server error';
        }
      }
    },
    forgottenPasswordIntroText() {
      return this.mode === 'leadbooker'
        ? `Please enter the email address you used to book and
                  we will send you an email with instructions on how to
                  reset your password`
        : `Please enter your email address and we will
                  send you an email with instructions on how to reset
                  your password`;
    },
    forgottenPassword_Confirmation() {
      return `Please check at <font style="font-size:1.1em;font-weight:bold;">${this.email}</font>.
                We've sent you instructions on how to set a password so that you can log in to your account.`;
    },
    resetPassword_Confirmation() {
      return 'Your new password has been saved, you can now proceed to the log in screen.';
    },
  },
  created() {
    // make sure user is logged out.
    // this.$store.dispatch('users/logOut'); // this causes unforseen logouts if currentUser state is not set even if user signed in (fetchCurrentUser callback sets currentUser state)

    this.mode = this.$route.query.g ? 'guest' : 'leadbooker';
    if (this.$route.query.reset) {
      this.showLogin_ResetPassword();
    }
    else if (this.$route.query.e && this.$route.query.f) {
      this.resetError();
      this.email = this.$route.query.e;
      this.requestReset();
    }
    else if (this.$route.query.t) {
      this.resetError();
      // fetch email for this token and set

      const self = this;
      self.$store.dispatch('users/fetchEmailFromToken', { token: this.$route.query.t, userType: self.mode }).then((res) => {
        self.email = res.data;
        self.checkForEmail();
      }).catch((error) => {
        // the token must be invalid - redirect to login
        self.showLogin_Step1();
      });
    }
    else {
      this.showLogin_Step1();
    }

    this.$validator.localize('en', this.errorMessages);
  },
  methods:
    {
      resetError() {
        this.serverError = false;
        this.serverError_emailnotfound = false;
        this.serverError_unauthed = false;
      },
      showLoading() {
        this.step = 'loading';
      },
      showLogin_Step1() {
        this.step = 'step1';
        this.heading = this.mode === 'leadbooker' ? 'Log in to Your Account' : 'Guest Access';
      },
      showLogin_Step2() {
        this.step = 'step2';
        this.resetError();
      },
      showLogin_ForgottenPassword() {
        this.step = 'forgottenpassword';
        this.heading = 'Forgot password';
        this.resetError();
      },
      showLogin_ForgottenPassword_Confirmation() {
        this.step = 'forgottenpassword_confirmation';
        this.heading = 'Email Sent';
        this.resetError();
      },
      showLogin_ResetPassword() {
        this.step = 'resetpassword';
        this.heading = 'Create/Reset password';
        this.resetError();
        const self = this;
        self.$store.dispatch('users/fetchEmailFromToken', { token: this.$route.query.t, userType: self.mode }).then((res) => {
          self.email = res.data;
          this.showOldSignIn();
        }).catch((error) => {
          // the token must be invalid - redirect to forgot password
          this.showOldSignIn()
          this.showLogin_ForgottenPassword()
          alert("The password reset link has expired or is invalid. Please request a new link.")
        });
      },
      showLogin_ResetPassword_Confirmation() {
        this.step = 'resetpassword_confirmation';
        this.heading = 'Password Saved!';
        this.resetError();
      },
      switchMode() {
        const self = this;
        self.showLoading();
        setTimeout(() => {
          self.mode = self.mode === 'leadbooker' ? 'guest' : 'leadbooker';
          // this.$router.push({ path: this.mode === 'leadbooker' ? this.leadBookerLoginURL : this.guestLoginURL })
          self.showLogin_Step1();
          self.resetError();
        }, 150);
      },
      showOldSignIn() {
        this.showOldSignInActive = !this.showOldSignInActive;
      },
      checkForEmail() {
        this.$validator.validate().then((valid) => {
          if (valid) {
            const self = this;
            self.showLoading();
            setTimeout(() => {
              self.$store.dispatch('users/checkIfEmailExists', { email: self.email, userType: self.mode }).then((res) => {
                self.showLogin_Step1();
              }).catch((error) => {
                self.showLogin_Step1();
                self.serverError = true;
              });
            }, 500);
          }
        });
      },
      auth() {
        this.$validator.validate().then((valid) => {
          if (valid) {
            const self = this;
            self.showLoading();
            setTimeout(() => {
              const auth = { email: self.email, password: self.password, userType: self.mode };
              self.$store.dispatch('users/logIn', auth).then((res) => {
                // logged in - now the login template will be replaced by the current template in app.vue
                self.$emit('usersigned', res.contact.id);
              }).catch((error) => {
                if (error.message && error.message.indexOf('404') > -1) {
                  self.serverError_emailnotfound = true;
                } else if (error.message && error.message.indexOf('401') > -1) {
                  self.serverError_unauthed = true;
                }
                self.showLogin_Step1();
                // console.log(error.message);
              });
            }, 500);
          }
        });
      },
      requestReset() {
        this.$validator.validate().then((valid) => {
          if (valid) {
            const self = this;
            self.showLoading();
            setTimeout(() => {
              self.$store.dispatch('users/requestPasswordResetEmail', { email: self.email, userType: self.mode }).then((res) => {
                self.showLogin_ForgottenPassword_Confirmation();
              }).catch((error) => {
                // failure
                self.showLogin_ForgottenPassword();
                self.serverError_emailnotfound = true;
              });
            }, 500);
          }
        });
      },
      resetPassword() {
        this.$validator.validate().then((valid) => {
          if (valid) {
            const self = this;
            self.showLoading();
            setTimeout(() => {
              self.$store.dispatch('users/resetPassword', { newPassword: self.newPassword, userType: self.mode, token: self.$route.query.t }).then((res) => {
                self.showLogin_ResetPassword_Confirmation();
              }).catch((error) => {
                // failure
                self.showLogin_ResetPassword();
                self.serverError = true;
              });
            }, 500);
          }
        });
      },
      showSignUp() {
        this.$emit('showSignUpClicked');
      },
      doFacebookLogin() {
        this.logInWithFacebook(this.mode); // SocialLogins mixin
      },
      doGoogleLogin() {
        this.loginWithGoogle(this.mode); // SocialLogins mixin
      },
      doAppleLogin() {
        this.logInWithApple(this.mode); // SocialLogins mixin
      },
      switchPasswordVisibility() {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
      },
    },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/settings/config.scss";

  .login_window_client_area {
    width: 400px;
    text-align: center;
    padding: 20px 30px;
    margin-top: 20px;

    @media (max-width: 400px) {
      width: 100% !important;
    }
  }

  .login_window_ob {
    padding: 2em 10px 10px;
  }

  .wave-grey {
    margin: 0.5em auto 1em;
  }

  .sign-up-link {
    // padding-top:20px;
    padding-bottom:20px;
  }

  .social-icons {
    display:inline-block;
    margin-bottom: 0px !important;
  }

  .social-icon {
   float: left;
   margin-right: 27px;
   margin-left: 27px;
   cursor: pointer;
  }

  .client-area-head {
    text-align: center;
    margin: 0.5em auto;
    line-height: 1.2;
    font-size: 28px;
    // max-width: 295px;
  }

  .client-area-content {
    text-align: left;
    margin-top: 2em;
    h2 {
      font-family: $font-family-grotesk;
      font-style: normal;
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 0.2em;
    }
    h3 {
      font-family: $font-family-grotesk;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.2;
      text-align: center;
      max-width: 295px;
      margin-top: 1em;
      margin-bottom: 0.5em;
      margin-left: auto;
      margin-right: auto;
    }
    p {
      margin-bottom: 1em;
    }
    a {
      margin-bottom: 1em;
      width: 100%;
    }
  }

  .travel-agent-help {
    h3 {
      font-size: 18px;
      font-weight: 500;
      line-height: 1.2;
      text-align: left;
      margin-top: 1em;
      margin-bottom: 0.5em;
    }
    p {
      text-align: left;
    }
  }

  .icon-hover:hover {
    color: $darkBlack !important
  }

  .diamond {
    background-color: $darkBlack;
    width: 7px;
    height: 7px;
    margin: 0 auto;
  }

    .ob-head {
    font-size: 16px;
    font-family: $font-family-grotesk;
    margin-bottom: 0;
  }

  .login_loading {
    padding-top: 60px;
    text-align: center;
  }

  .login_buttons button {
    width: 100%;
    margin-bottom: 10px;
  }

  .login_bottom {
    text-align: center;
    margin-bottom: 20px;
  }

  .forgot_bottom {
    // padding-top: 23px; /*removing this padding will make the "Forgot Password" link unclickable*/
    text-align: right;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .login_or {
    margin: 10px 0 20px;
    text-align: center;
  }

  .login_reset {
    div {
      margin-bottom: 1em;
    }
  }

  .login_errors {
    text-align: center;
    margin-bottom: 20px;
    color: red;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .credentials {
    border: 1px solid $grey;
    height: 50px;
    color: $black;
    width: 100%;
    margin-bottom: 0.5em;
  }

  .cursor {
    cursor: pointer;
  }

  .clicked {
    transform: scale(0.8);
  }

  .btn-back {
    text-align:left;
    float:left
  }

  .btn-close {
    float:right;
    & img {
      height: 10px;
    }
  }
  .cross {
    margin-top: 5.5px
  }

</style>
